module.exports = __webpack_public_path__ + "static/media/CheckboxFilledKTMNew.b8b3d35d.svg";